import * as PropTypes from "prop-types";
import styled from "styled-components";
import SearchSvg from "./PhoneIcon.svg";
import Icon from "./Icon";

export default function PhoneIcon({ className, style }) {
  const localStyle = {
    width: "1.6rem",
    ...style,
  };

  return (
    <Wrapper>
      <Icon src={SearchSvg} className={className} style={localStyle} />
    </Wrapper>
  );
}

PhoneIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

PhoneIcon.defaultProps = {
  className: "",
  style: {},
};

const Wrapper = styled.div`
  div {
    width: 1.6rem;
    margin-right: 14px;
    margin-top: 10px;
  }

  @media (max-width: 693px) {
    position: absolute;
    right: 190px;
  }

  ${({ theme }) => theme.phone`
    position: absolute;
    right: 146px;
  `};

  div img {
    width: 1.5rem;
  }
`;
